export default function(value) {
  if (value.records) {
    return value.records.map(({ value }) => value).join(", ");
  }
  return value;
}
